import React from 'react'

const EstrellaRating = ({ calificacion, alCambiar, alCambiarCalificacion, soloLectura = false, tamaño = 'md' }) => {
  const tamañoPixeles = {
    sm: '16px',
    md: '24px',
    lg: '32px'
  }

  const tamanioActual = tamañoPixeles[tamaño]

  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      {[1, 2, 3, 4, 5].map((estrella) => (
        <button
          key={estrella}
          type="button"
          disabled={soloLectura}
          onClick={() => !soloLectura && (alCambiar || alCambiarCalificacion)?.(estrella)}
          style={{
            width: tamanioActual,
            height: tamanioActual,
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: soloLectura ? 'default' : 'pointer',
            transition: 'transform 0.2s',
            transform: 'scale(1)'
          }}
          onMouseEnter={(e) => {
            if (!soloLectura) {
              e.currentTarget.style.transform = 'scale(1.1)'
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)'
          }}
        >
          <svg
            style={{
              width: '100%',
              height: '100%',
              fill: estrella <= calificacion ? '#FBBF24' : '#D1D5DB'
            }}
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        </button>
      ))}
    </div>
  )
}

export default EstrellaRating